import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=37038650&scoped=true&"
import script from "./upload-image.vue?vue&type=script&lang=js&"
export * from "./upload-image.vue?vue&type=script&lang=js&"
import style0 from "./upload-image.vue?vue&type=style&index=0&id=37038650&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37038650",
  null
  
)

export default component.exports